<template>
  <div
    @click="handleContainerClick"
    class="profileListingCardDv"
    v-if="userData"
    :class="{
      compact: hideActions,
      'c-pointer':
        (!fromInfluncersPopup || fromExplore) || onboardingCardFollowMode,
      frombuzz: frombuzz,
      'profile-card--onboarding-selectable': onboardingCardFollowMode,
      'profile-card--onboarding-following':
        onboardingCardFollowMode && userData.isFollowing,
      'profile-card--onboarding-busy':
        onboardingCardFollowMode && connectionActionLoading,
    }"
  >
    <div class="profileListingCardHeadDv">
      <figure>
        <img
          :src="images.coverPhoto"
          @error="handleCoverPhotoError"
          crossorigin="anonymous"
        />
      </figure>
    </div>

    <div class="profileListingCardBodyDv">
      <div class="firstinfoListingCardDV">
        <div class="user_detail">
          <ProfileAvatarComponent
            v-if="images.profilePicture"
            :key="images.profilePicture"
            :profileImage="images.profilePicture"
            :border="true"
            :badges="false"
            :redirectProfile="!suppressProfileNavigation"
            class="extramedium extraProfileDv"
            :class="{ xsmall: isMobile }"
            style="
              margin-inline-end: auto !important;
              margin-inline-start: auto !important;
            "
            @profileClick="goToProfile"
          />
          <div v-else style="height: 12px; margin-bottom: 4.25px">
            <!-- <div class="loader" style="margin: 0 auto"></div> -->
          </div>

          <el-tooltip
            v-if="shouldShowNameTooltip"
            class="box-item"
            effect="dark"
            :content="userData.fullName"
          >
            <h2 ref="fullName" @click.stop="goToProfile">
              {{ formattedFullName }}
            </h2>
          </el-tooltip>

          <h2 v-else ref="fullName" @click.stop="goToProfile">
            {{ formattedFullName }}
          </h2>
        </div>

        <div class="userName">
          <p
            style="color: var(--base-light-text)"
            v-if="userData.userName"
            @click.stop="goToProfile"
          >
            @{{ userData.userName }}
          </p>
          <p v-else class="dummy-height"></p>
        </div>

        <div class="infoCategory">
          <p v-if="userData.attribute" :style="{ color: attributeColor }">
            {{ $t(getLabel(userData.attribute)) }}
          </p>
          <p v-else class="dummy-height"></p>
        </div>

        <div v-if="isCurrentUser" class="connection_buttons_wrapper">
          <button class="btn btn--grayscale infoBohtDv">
            <IconComponent class="respondIconDv" icon="icon-you.svg" />
            ({{ $t("common.actions.you") }})
          </button>
        </div>

        <template v-if="fromProfile && !isCurrentUser && !onboardingCardFollowMode">
          <ConnectionButton
            :profile="userData"
            @click.stop="preventProfileClick"
            @updateUserData="$emit('updateUserData')"
          />
        </template>

        <template v-if="fromUnBlock">
          <button
            class="btn btn--grayscale infoBohtDv"
            v-if="isFollowingLoading"
          >
            <div class="loader"></div>
          </button>
          <button
            class="btn btn--grayscale infoBohtDv"
            v-else
            @click="unBlockUsers"
          >
            {{ $t("common.actions.unblock") }}
          </button>
        </template>
      </div>

      <div class="secondinfoListingCardDV">
        <div class="secondinfoListingCardDV" v-if="hasSectionStats">
          <div class="firstDv">
            <div class="labelDv" v-for="item in sectionStats" :key="item.key">
              <el-tooltip
                v-if="isOverflowingTwo"
                class="box-item"
                effect="dark"
                :content="item.label"
                placement="top-start"
              >
                <h2 class="statsLabel" ref="symbolElementTwo">
                  {{ formatStatLabel(item.key) }}
                </h2>
              </el-tooltip>

              <h2 v-else class="statsLabel" ref="symbolElementTwo">
                {{ formatStatLabel(item.key) }}
              </h2>

              <p>
                {{ formatWithComma(formatStatValue(item)) }}
              </p>
            </div>
          </div>
        </div>

        <div class="secondinfoListingCardDV" v-else>
          <div class="firstDv">
            <div class="labelDv">
              <h2 ref="label" class="statsLabel">
                {{ $t("common.common.followers") }}
              </h2>
              <p>{{ formatWithComma(userData.followersCount) }}</p>
            </div>
            <div class="labelDv">
              <h2 class="statsLabel">{{ $t("common.common.following") }}</h2>
              <p>{{ formatWithComma(userData.followingCount) }}</p>
            </div>
          </div>
        </div>

        <div class="stockGridDv" v-if="hasStocks">
          <template v-for="item in displayedStocks" :key="item.stockId">
            <el-tooltip
              class="box-item"
              effect="dark"
              :content="item.symbol?.toUpperCase()"
              placement="top-start"
            >
              <StockImageTag
                class="stocktag"
                :stockId="item.stockId"
                :imgUrl="item.logoUrl"
                :symbol="item.symbol"
                :market="item?.type?.toLowerCase()"
                :disable-routing="suppressProfileNavigation"
              />
            </el-tooltip>
          </template>
          <p class="stocksLength noStockContainer" v-if="hasAdditionalStocks">
            +{{ additionalStocksCount }}
          </p>
        </div>
        <div class="stockGridDv" v-else>
          <div class="noStockContainer" v-if="!userData.stocks">
            {{ userData.isFollowing ? "Add Friend" : "Follow" }} to View
          </div>
          <template v-else-if="!userData.stocks.length">
            <div v-for="i in 4" :key="i" class="noStockContainer" style="border: none;"></div>
          </template>
        </div>
      </div>
    </div>

    <div class="profileListingCardfooterDv" v-if="hasStocks">
      <div
        class="stock_stats secondinfoBodyDv"
        :class="{ 'f-gray': !userData.stocks?.length }"
        ref="stocksRow"
      >
        <template v-for="stat in stockStatsData" :key="stat.title">
          <el-tooltip
            class="box-item"
            effect="dark"
            :content="`${$t(`common.common.${$t(stat.title.toLowerCase())}`)}(${
              stat.count
            })`"
            placement="top-start"
          >
            <div
              v-if="stat.maxWidth > 0"
              class="stat"
              :style="{ maxWidth: stat.maxWidth + '%' }"
            >
              <div class="color" :style="{ background: stat.color }"></div>
            </div>
            <div v-else></div>
          </el-tooltip>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  onUnmounted,
  nextTick,
  watch,
  PropType,defineAsyncComponent
} from "vue";
import { useRouter } from "vue-router";
import { useDebounceFn } from "@vueuse/core";
import { RouteEnum } from "@/router/routeNames";
import storageService from "@/services/storage.service";
import utilService from "@/services/util.service";
import { loadImageWithTracking } from "@/helpers/image.helpers";
import { SocketStock } from "@/helpers/models/stock/socket_stock.model";
import httpService from "@/services/http.service";
import { useI18n } from "vue-i18n";
import { useCommonKey } from "@/composables/commonkey.composable";
import { ConnectionComposables } from "@/composables/connection/connection.composable";

const ProfileAvatarComponent = defineAsyncComponent(() => import('@/components/ProfileAvatarComponent.vue'));
const ConnectionButton = defineAsyncComponent(() => import('@/components/ConnectionButton.vue'));
const StockImageTag = defineAsyncComponent(() => import('@/components/StockImageTag.vue'));

interface UserProfile {
  _id: string;
  fullName?: string;
  userName: string;
  profilePicture?: string;
  coverPhoto?: string;
  attribute?: {
    name: string;
    color?: string;
  };
  sectionStats?: Array<{
    label: string;
    value?: number;
    key: string;
  }>;
  stats?: Record<string, number>;
  followersCount: number;
  followingCount: number;
  friendCount: number;
  outreach?: number;
  stocks?: SocketStock[];
  isFollowing?: boolean;
}

interface Stock {
  stockId: string;
  symbol: string;
  logoUrl?: string;
  type?: string;
}

interface ImageData {
  profilePicture: string;
  coverPhoto: string;
}

export default defineComponent({
  name: "ProfileCard",
  components: {
    ProfileAvatarComponent,
    ConnectionButton,
    StockImageTag,
  },
  props: {
    fromOutside: Boolean,
    frombuzz: Boolean,
    fromUnblockListing: Array,
    fromUnBlock: Boolean,
    fromProfile: Boolean,
    userData: Object as PropType<UserProfile>,
    hideActions: Boolean,
    fromInfluncersPopup: Boolean,
    /** Create-profile / auth onboarding: never route (profile, stocks, or container). */
    fromOnboarding: Boolean,
    fromExplore: Boolean,
  },
  setup(props, { emit }) {
    const router = useRouter();
    const { t } = useI18n();
    const { commonKey } = useCommonKey();
    const { onFollow, unfollow, isFollowingLoading: connectionActionLoading } =
      ConnectionComposables();
    
    // Refs
    const images = ref<ImageData>({
      profilePicture: "",
      coverPhoto: "",
    });

    const isOverflowing = ref(false);
    const isOverflowingTwo = ref(false);
    const isMobile = ref(false);
    const isFollowingLoading = ref(false);
    const fullName = ref<HTMLElement | null>(null);
    const symbolElementTwo = ref<HTMLElement | null>(null);
    const stocksRow = ref<HTMLElement | null>(null);
    const totalData = ref<any[]>([]);

    // Computed
    const currentUser = computed(() => storageService.user.value);
    const suppressProfileNavigation = computed(
      () => Boolean(props.fromInfluncersPopup || props.fromOnboarding)
    );
    const isCurrentUser = computed(
      () => currentUser.value?._id === props.userData._id
    );

    /** Create-profile onboarding: card click follows; border shows state (guest / pending requests still use ConnectionButton). */
    const onboardingCardFollowMode = computed(() => {
      if (!props.fromOnboarding || !props.fromProfile || isCurrentUser.value) {
        return false;
      }
      const u = currentUser.value as { isGuestUser?: boolean } | null | undefined;
      if (!u || u.isGuestUser) return false;
      const p = props.userData as UserProfile & {
        isFriend?: boolean;
        requestReceiveData?: unknown;
        requestSentData?: unknown;
      };
      if (p.isFriend || p.requestReceiveData || p.requestSentData) return false;
      return true;
    });

    const formattedFullName = computed(() =>
      props.userData.fullName
        ? utilService.convertToTitleCase(props.userData.fullName)
        : "-"
    );

    const shouldShowNameTooltip = computed(
      () => isOverflowing.value && props.userData.fullName
    );

    const attributeColor = computed(() => {
      if (!props.userData.attribute) return "";
      return (
        props.userData.attribute.color ||
        utilService.getAttributeColor(props.userData.attribute.name)
      );
    });

    const sectionStats = computed(() => {
      if (!props.userData.sectionStats) return [];
      return props.userData.sectionStats.slice(0, 2).map((stat) => ({
        ...stat,
        value: props.userData.stats?.[stat.key] ?? stat.value,
      }));
    });

    const hasSectionStats = computed(
      () => props.userData.sectionStats?.length > 0
    );

    const hasStocks = computed(() => props.userData.stocks?.length > 0);

    const displayedStocks = computed(
      () => props.userData.stocks?.slice(0, 3) || []
    );

    const hasAdditionalStocks = computed(
      () => (props.userData.stocks?.length || 0) > 3
    );

    const additionalStocksCount = computed(
      () => (props.userData.stocks?.length || 0) - 3
    );

    const stockStatsData = computed(() => {
      if (!stocksRow.value) return [];
      return utilService.getStocksBar(
        props.userData.stocks || [],
        stocksRow.value.clientWidth
      );
    });

    // Methods
    const loadProfileImages = async () => {
      try {
        // Convert profile picture count to number or default to 0
        const profilePicCount = props.userData.profilePicture
          ? parseInt(props.userData.profilePicture)
          : 0;

        // Convert cover photo count to number or default to 0
        const coverPhotoCount = props.userData.coverPhoto
          ? parseInt(props.userData.coverPhoto)
          : 0;

        // Define fallback URLs
        const profileFallback = utilService.getImageUrl("avatar_men.png", null);
        const coverFallback = utilService.getImageUrl("dummy-cover.png", null);

        const [profileResult, coverResult] = await Promise.all([
          loadImageWithTracking({
            src: utilService.getUserProfilePicture(
              props.userData._id,
              profilePicCount,
              "male",
              false,
              false
            ),
            altSrc: profileFallback,
            userId: props.userData._id,
            context: "profile-picture",
          }),
          loadImageWithTracking({
            src: utilService.getUserProfilePicture(
              props.userData._id,
              coverPhotoCount,
              "male",
              true,
              false
            ),
            altSrc: coverFallback,
            userId: props.userData._id,
            context: "cover-photo",
          }),
        ]);

        images.value = {
          profilePicture: profileResult.success
            ? profileResult.loadedSrc
            : profileFallback,
          coverPhoto: coverResult.success
            ? coverResult.loadedSrc
            : coverFallback,
        };
      } catch (error) {
        console.error("Error loading profile images:", error);
        images.value = {
          profilePicture: utilService.getImageUrl("avatar_men.png", null),
          coverPhoto: utilService.getImageUrl("dummy-cover.png", null),
        };
      }
    };
    const handleCoverPhotoError = (event: Event) => {
      const target = event.target as HTMLImageElement;
      target.src = utilService.coverImageError();
    };

    const checkOverflow = useDebounceFn(() => {
      if (fullName.value) {
        isOverflowing.value =
          fullName.value.scrollWidth > fullName.value.clientWidth;
      }
    }, 100);

    const checkOverflowTwo = () => {
      nextTick(() => {
        if (symbolElementTwo.value) {
          isOverflowingTwo.value =
            symbolElementTwo.value.scrollWidth >
            symbolElementTwo.value.clientWidth;
        }
      });
    };

    const checkMobileView = () => {
      isMobile.value = window.matchMedia("(max-width: 767px)").matches;
    };

    const formatStatLabel = (key: string) => {
      const labelMap: Record<string, string> = {
        "Top Gain %": "Top % Gain",
        "Avg Gain %": "Avg % Gain",
      };
      // return labelMap[label] || label;
      return t(`profile.stats.${key}`);
    };

    const formatStatValue = (item: any) => {
      if (
        [
          "Avg Gain %",
          "Top Gain %",
          "Top % Gain",
          "Avg % Gain",
          "Avg Gains",
          "Top Gains",
        ].includes(item.label)
      ) {
        return `${item.value ? item.value.toFixed(2) : 0}%`;
      }

      if (item.label === "Followers") return props.userData.followersCount;
      if (item.label === "Following") return props.userData.followingCount;
      if (item.label === "Friends") return props.userData.friendCount;
      if (item.label === "Outreach") return props.userData.outreach;

      return utilService.getStatsValue(item.key, item.value ?? 0);
    };

    const handleOnboardingFollowToggle = async () => {
      if (!onboardingCardFollowMode.value || !props.userData) return;
      if (connectionActionLoading.value) return;
      const p = props.userData as UserProfile & { _id: string };
      document.body.click();
      if (p.isFollowing) {
        setTimeout(async () => {
          const ok = await unfollow(p._id);
          if (ok) {
            p.isFollowing = false;
            if (typeof p.followersCount === "number" && p.followersCount > 0) {
              p.followersCount--;
            }
            emit("updateUserData", true);
          }
        }, 200);
      } else {
        await onFollow(p);
        emit("updateUserData", true);
      }
    };

    const handleContainerClick = () => {
      if (onboardingCardFollowMode.value) {
        void handleOnboardingFollowToggle();
        return;
      }
      if (suppressProfileNavigation.value) {
        return;
      }
      if (props.fromExplore || props.fromProfile) {
        goToProfile();
      }
    };

    const isUserLoggedIn = (): boolean => {
      const token = storageService.getToken();
      const user = storageService.getUser();
      return !!((token && user && user._id) || commonKey.value);
    };
    
    const goToProfile = () => {
      if (suppressProfileNavigation.value) {
        return;
      }
      // When fromOutside, check if user is logged in to decide which route to use
      if (props.fromOutside) {
        if (isUserLoggedIn()) {
          // User is logged in, navigate to private profile route
          router.push({
            name: RouteEnum.profile,
            params: { username: props.userData.userName },
          });
        } else {
          // User is not logged in, navigate to public profile route
          router.push({
            name: "publicProfileShortChild",
            params: { username: props.userData.userName },
          });
        }
      } else {
        router.push({
          name: RouteEnum.profile,
          params: { username: props.userData.userName },
        });
      }
      setTimeout(() => emit("onCardClicked"));
    };

    const preventProfileClick = (event: Event) => {
      event.stopPropagation();
      emit("connectionClicked");
    };

    const unBlockUsers = async () => {
      try {
        document.body.click();
        const confirmRes = await utilService.showConfirmationDialog(
          "Are you sure you want to Unblock?"
        );

        if (confirmRes) {
          isFollowingLoading.value = true;
          const response = await httpService.unBlockUser({
            blockedId: props.userData._id,
          });

          if (response.data.isSuccess) {
            utilService.showToast("User Unblocked");

            // Update blocked users list in storage
            const blockedUsers =
              storageService.GetProperty("blockedUsers") || [];
            if (blockedUsers.includes(props.userData._id)) {
              storageService.SetProperty(
                "blockedUsers",
                blockedUsers.filter((x: string) => x !== props.userData._id)
              );
            }

            // Remove from unblock listing if applicable
            const index = props.fromUnblockListing?.findIndex(
              (x: any) => x._id === props.userData._id
            );
            if (index !== -1) {
              props.fromUnblockListing?.splice(index, 1);
            }

            emit("removeFromList", true);
          }
        }
      } catch (error) {
        console.error("Error unblocking user:", error);
      } finally {
        isFollowingLoading.value = false;
      }
    };

    // Lifecycle
    onMounted(() => {
      loadProfileImages();

      // Set up overflow observers
      const resizeObserver = new ResizeObserver(checkOverflow);
      if (fullName.value) {
        resizeObserver.observe(fullName.value);
      }

      // Set up mobile view check
      checkMobileView();
      window.addEventListener("resize", checkMobileView);

      // Initial overflow checks
      checkOverflow();
      checkOverflowTwo();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", checkMobileView);
      // clearImageCache();
    });

    const attributesList = ref<any[]>(utilService.attributesList);

    const getLabel = (item: any) => {
      return (
        attributesList.value.find((attribute) => attribute.name == item.name)
          ?.label ?? item.name
      );
    };

    const formatWithComma = (num: number | string) => {
      if (!num && num !== 0) return num;
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    return {
      formatWithComma,
      images,
      isOverflowing,
      isOverflowingTwo,
      isMobile,
      isFollowingLoading,
      fullName,
      symbolElementTwo,
      stocksRow,
      totalData,
      currentUser,
      suppressProfileNavigation,
      isCurrentUser,
      formattedFullName,
      shouldShowNameTooltip,
      attributeColor,
      sectionStats,
      hasSectionStats,
      hasStocks,
      displayedStocks,
      hasAdditionalStocks,
      additionalStocksCount,
      stockStatsData,
      handleCoverPhotoError,
      formatStatLabel,
      formatStatValue,
      handleContainerClick,
      goToProfile,
      preventProfileClick,
      onboardingCardFollowMode,
      connectionActionLoading,
      unBlockUsers,
      getLabel,
      attributesList,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "./_profile-card";

.profileListingCardDv {
  position: relative;

  .stockGridDv {
    z-index: 100;
  }
}

.profileListingCardDv.profile-card--onboarding-selectable {
  border: 2px solid var(--base-new-border);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &.profile-card--onboarding-following {
    border: 2px solid var(--recommend-hold);
    box-shadow: 0 0 0 1px rgba(var(--new-theme-color-rgb), 0.35);
  }

  &.profile-card--onboarding-busy {
    pointer-events: none;
    opacity: 0.72;
  }

  .profileListingCardBodyDv .firstinfoListingCardDV {
    h2,
    .userName p {
      cursor: inherit;

      &:hover {
        opacity: 1;
      }
    }
  }
}

.f-gray {
  filter: grayscale(0.5);
}

.stocksLength {
  font-size: var(--font-2xs);
  color: var(--base-text);
}

.dummy-height {
  min-height: 20px;
}

.infoBohtDv {
  padding: 0px 8px;
  font-size: var(--font-2sm);
  border-radius: 6px !important;
  line-height: 1;
  letter-spacing: 0px;
  font-weight: 600;
  min-width: 110px;
  width: auto !important;
  height: 26px;
  min-height: 26px;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  margin: 0px;

  .respondIconDv {
    width: 20px;
    height: 20px;
    margin-inline-end: 0px;
    margin-top: 1px;
  }
}

.frombuzz {
  .profileListingCardBodyDv {
    z-index: 5 !important;
  }
}

.profileListingCardDv .profileListingCardBodyDv .firstinfoListingCardDV {
  gap: 8px;

  p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    padding: 0px;
  }

  .follow_row {
    margin: 3px 0;
  }

  :deep(.follow_row) {
    button {
      background: var(--base-lightest);
    }
  }
  h2,
  .userName p {
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
}

@media only screen and (min-width: 1280px) and (max-width: 1891px) {
  .profileListingCardDv .profileListingCardBodyDv .firstinfoListingCardDV {
    gap: 0;

    .follow_row {
      margin: 0;
    }
  }

  .profile_container.extramedium > .polytar {
    width: 60px;
    height: 60px;
  }

  .profile_container.extramedium > .polytar > .spacing {
    width: 54px;
    height: 54px;
  }

  .profile_container.extramedium > .polytar > .spacing > div {
    width: 48px;
    height: 48px;
  }

  .profiles-body .listing .profileListingCardDv {
    max-width: 190px !important;
    width: 190px !important;
    flex: 0 0 190px !important;
  }

  .profileListingCardDv {
    .profileListingCardBodyDv {
      gap: 12px;
      padding-bottom: 12px;

      .firstinfoListingCardDV {
        h2 {
          width: 100%;
          font-size: var(--font-xs);
          margin-top: -3px;
        }

        p {
          font-size: var(--font-2xs);
        }

        button {
          font-size: var(--font-2xs) !important;
          min-height: 26px !important;
          min-width: 94px;
          font-weight: 400;
        }
      }

      .secondinfoListingCardDV {
        gap: 12px;

        .firstDv .labelDv {
          min-height: 40px;
          height: 44px;
          padding: 6px;

          h2 {
            font-size: 10px;
          }

          p {
            font-size: 13px;
          }
        }

        .stockGridDv {
          gap: 5px;

          .noStockContainer {
            min-height: 30px;
            height: 30px;
            max-width: 30px;
            width: 30px;
            font-size: var(--font-3xs) !important;
            border-radius: 8px;
          }
        }
      }
    }
  }
}
</style>
